export const RR_BLACK = '#000';
export const RR_WHITE = '#fff';
export const RR_GRAY_200 = '#eeeeee';
export const RR_GRAY_650 = '#707070';
